﻿$.fn.extend({
    animateCss: function (animationName, callback) {
        var animationEnd = (function (el) {
            var animations = {
                animation: 'animationend',
                OAnimation: 'oAnimationEnd',
                MozAnimation: 'mozAnimationEnd',
                WebkitAnimation: 'webkitAnimationEnd',
            };

            for (var t in animations) {
                if (el.style[t] !== undefined) {
                    return animations[t];
                }
            }
        })(document.createElement('div'));

        this.addClass('animated ' + animationName).one(animationEnd, function () {
            $(this).removeClass('animated ' + animationName);

            if (typeof callback === 'function') callback();
        });

        return this;
    },
});

$(function () {
    let notificationDismissed = false; // Track if the user already click to dismiss the notifications

    $("#notification-bar .action-dismiss").click(function (event) {
        // Don't allow this to be fired multiple times
        if (notificationDismissed) {
            return;
        }

        var $currentTarget = $(event.currentTarget);
        var notificationId = $currentTarget.data('notification-id');

        notificationDismissed = true;

        $.post('/account/dismissnotification?notificationId=' + notificationId.toString())
            .done(function () {
                $currentTarget.parents("#notification-bar").fadeOut();
            });

        
    });
});

$.fn.progressRing = function () {
    this.each((idx, elem) => {
        const $elem = $(elem);
        const pct = $elem.data('progress-percent');
        const val = $elem.data('progress-value');
        const color = $elem.data('progress-color');
        const className = $elem.data('progress-class');
        const height = $elem.height();
        const halfHeight = height / 2;
        const strokeWidth = 3;
        const radius = halfHeight - (strokeWidth * 2);

        const circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");

        const $circle = $(circle);

        $circle.attr({
            'class': `progress-ring-circle`,
            'stroke' : color,
            'stroke-width' : strokeWidth,
            'fill': 'transparent',
            'r': radius,
            'cx' : halfHeight,
            'cy' : halfHeight
        });

        const baseCircle = $circle[0].cloneNode();
        $elem[0].appendChild(baseCircle);

        const circumference = radius * 2 * Math.PI;
        circle.style.strokeDasharray = `${circumference} ${circumference}`;

        // Ensure that every circle starts off at 10% so it at least shows 
        // in the UI.We compress the actual percentage by 10 % so we can 
        // start off at 10 % and that the passed in percentage scales correctly.
        const adjustedPct = (pct * .9) + 10;

        const offset = circumference - adjustedPct / 100 * circumference;
        circle.style.strokeDashoffset = offset;
        circle.setAttribute('class', 'progress-ring-circle ' + className);

        $elem[0].appendChild($circle[0]);
        

        // If there is a value to display, do it.
        if (val != null && val != '') {
            const text = document.createElementNS("http://www.w3.org/2000/svg", "text");
            const $text = $(text);

            $text.attr({
                'x': '50%',
                'y': '50%',
                'text-anchor': 'middle',
                'dy': '.3em',
                'font-size': '0.7em',

            });

            $text[0].textContent = val;

            $elem[0].appendChild($text[0]);
        }
    });
}

/*
* Function that tracks a click on an outbound link in Analytics.
* This function takes a valid URL string as an argument, and uses that URL string
* as the event label. Setting the transport method to 'beacon' lets the hit be sent
* using 'navigator.sendBeacon' in browser that support it.
*/
window.trackEvent = function (event_name, event_category, event_label, extraParams) {
    $(function () {
        if (typeof gtag !== 'undefined') {
            var eventParams = {
                'event_category': event_category,
                'event_label': event_label
            };

            eventParams = Object.assign(eventParams, extraParams || {});

            gtag('event', event_name, eventParams);
        }

        if (typeof window.clarity !== 'undefined') {
            window.clarity("event", event_name);
        }
        /*
        window.LOQ = window.LOQ || [];
        window.LOQ.push(['ready', async LO => {
            await LO.$internal.ready('events');
            LO.events.track(event_name);
        }]);
        */
    });
}

window.VoterFly = window.VoterFly || {};

window.VoterFly.UI = {

    getHeaderHeight() {
        return Math.ceil($('header nav.navbar-fixed-top').height());
    },

    /**
     * 
     * Creates an overlay and places the HTML content within the overlay
     * @param {any} html
     * @returns
     */
    overlay: function (elemOrHtml, opts) {

        let defaultOpts = {
            zIndex: null,
            blur: true,
            color: 'black'
        };

        const combinedOpts = { ...defaultOpts, ...opts };

        const $contentElement = $(`<div class="vf-overlay-content"></div>`);

        $contentElement.append(elemOrHtml);

        $overlay = $('<div class="vf-overlay" style="display:none;"></div>');
        $overlay.append($contentElement);

        $('body').append($overlay);

        let zIndex = combinedOpts.zIndex;

        // Try to get the zIndex from the first element
        if (!zIndex) {
            const $firstChild = $contentElement.children().first();
            zIndex = $firstChild.css('z-index');
        }

        if (zIndex && Number.isInteger(Number.parseInt(zIndex, 10))) {
            $overlay.css('z-index', parseInt(zIndex, 10) - 1);
        }

        $overlay.addClass(combinedOpts.color);

        if (combinedOpts.blur) {
            $overlay.addClass('blur');
        }

        $('html').addClass('vf-has-overlay');

        $overlay.show();

        return {
            $overlay: $overlay,

            hide() {
                this.$overlay.hide();
                this.$overlay.remove();
                this.$overlay = null;

                // If there are no more overlays in the page, remove the class vf-has-overlay
                if ($('.vf-overlay').length == 0) {
                    $('html').removeClass('vf-has-overlay');
                }
            }
        }
    },

    /**
     * Creates a dark overlay over the site directly beneath the element passed in.
     * @param {any} element
     */
    backdrop: function (element) {
        $element = $(element);
        let zIndex = $element.css('z-index');

        let $backdrop = $('#backdrop');

        if ($backdrop.length === 0) {
            $backdrop = $('<div id="backdrop" style="display:none;"></div>');

            $('body').append($backdrop);

            $backdrop = $('#backdrop');
        }

        $backdrop.addClass('active');
        $backdrop.css('z-index', parseInt(zIndex, 10) - 1);
        $backdrop.show();
    },

    /**
     * Hids any previously displayed backdrop
     * */
    hideBackdrop() {
        let $backdrop = $('#backdrop');
        $backdrop.removeClass('active');
        $backdrop.hide();
    }, 

    showModalFromUrl : function(url, preventFade) {
        var $modal = $($('#modal-script-template').html());

        if (preventFade) {
            $modal.removeClass('fade');
        }

        $.get(url, null, function (data) {
            $modal.find('.modal-content').html(data);

            var modalInstance = $modal.modal();
        })
    },

    /**
     * *
     * @param {any} title
     * @param {any} content
     * @param {any} buttons array of objects, [{ content : '', command : '', className : '' }]
     * @param {any} setupCallback a callback that gets an instance of the modal to wire up event handlers
     */
    showModal: function (title, content, buttons, preventFade, setupCallback) {
        var $modal = $($('#modal-script-template').html());

        $modal.find('.modal-title').html(title);
        $modal.find('.modal-body').html(content);

        if (preventFade) {
            $modal.removeClass('fade');
        }

        const $footer = $modal.find('.modal-footer');
        if (!buttons) {
            $footer.hide();
        } else {

            buttons.forEach(button => {
                const $btn = $('<button class="btn"></button>');
                $btn.html(button.content);

                if (button.command) {
                    $btn.data('command', button.command);
                }

                if (button.className) {
                    $btn.addClass(button.className);
                }

                $btn.on('click')

                $footer.append($btn);
            });
        }

        var modalInstance = $modal.modal();

        if (setupCallback) {
            setupCallback(modalInstance);
        }

        var promise = new Promise((resolve) => {
            $(modalInstance).on('click', '.modal-footer button', function (e) {
                const $btn = $(e.currentTarget);
                const command = $btn.data('command');
                resolve(command);
                $modal.modal('hide');
                $(modalInstance).off('click');
                $modal[0].remove();
            });

            $(modalInstance).on('hidden.bs.modal', function (e) {
                $(modalInstance).off('click');
                $modal[0].remove();
                resolve('close');
            });
        });

        return promise;
    },

    showLoader: function (opts) {
        if (!opts) { opts = {}; }

        let $loadingOverlay = $('#loading-overlay');

        if ($loadingOverlay.length === 0) {
            $loadingOverlay = $(`
                <div id="loading-overlay" style="display:none;">
                    <span class="style-spinner-content">
                        <i class="fas fa-spinner fa-pulse loading-icon"></i>
                    </span>
                    <div class="style-percent-content"></div>
                </div>
            `);

            $('body').append($loadingOverlay);

            $loadingOverlay = $('#loading-overlay');
        }

        $loadingOverlay.removeClass('style-percent');
        $loadingOverlay.removeClass('style-spinner');

        if (opts.percent) {
            $loadingOverlay.addClass('style-percent');
        } else {
            $loadingOverlay.addClass('style-spinner');
        }

        $loadingOverlay.show();

        $pctContent = $loadingOverlay.find('.style-percent-content');

        return {
            setProgress: function (pct) {
                $pctContent.text(Math.round(pct) + '%');
            }
        }
    },

    hideLoader: function () {
        $('#loading-overlay').hide();
    },

    showMediaPopup: function (mediaUrl, mediaTitle, mediaDescription) {

        let $popup = $('#media-popup');

        if ($popup.length === 0) {
            const popupHtml = `
                <div id="media-popup">
                    <div class="contents">
                        <div class="image-holder">
                            <img class="img-responsive" />
                        </div>
                        <h4 class="title" />
                        <span class="description"></span>
                    </div>
                </div>`;

            $('body').append($(popupHtml));

            $popup = $('#media-popup');

            $popup.click(function () {
                $('body').css('overflow', 'auto');
                $popup.find('.image-holder img').attr('src', null);
                $popup.hide();
            });
        }

        $('body').css('overflow', 'hidden');
        $popup.removeClass('has-image');
        $popup.removeClass('has-description');

        $popup.find('.title').text(mediaTitle);

        $popup.find('.image-holder img').attr('src', mediaUrl);
        if (mediaUrl) { $popup.addClass('has-image'); }

        $popup.find('.description').text(mediaDescription);
        if (mediaDescription) { $popup.addClass('has-description'); }

        $popup.show();
    },

    loadAvatarImages: function ($targetElem) {
        $targetElem.find('img.avatar').each(function () {
            var $img = $(this);
            var image = new Image();

            image.onerror = function () {
                $img.attr('src', '/images/anonymous_person_icon.png');
            }

            image.onload = function () {
                $img.attr('src', image.src);
            }

            image.src = $(this).data('lazy-load-src');

            $img.attr('src', '/images/anonymous_person_icon.png');
        });
    }
}